import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ErrorNormalized } from '../../errors/models/error.model';
import { PushNotificationStatus } from '../models/push-notification-status.model';

interface PushNotificationState {
    status: PushNotificationStatus,
    error?: ErrorNormalized,
    applicationServerKey: string
}

type StatusPayload = PayloadAction<{
    status: PushNotificationStatus,
    error?: ErrorNormalized
}>;

const initialState: PushNotificationState = {
    status: 'initializing',
    applicationServerKey: '__',
};

export const pushNotificationSlice = createSlice({
    initialState,
    name: 'pushNotifications',
    reducers: {
        setKey(state, action: PayloadAction<{ applicationServerKey: string }>) {
            state.applicationServerKey = action.payload.applicationServerKey;
        },
        setStatus(state, action: StatusPayload) {
            state.error = action.payload.error;
            state.status = action.payload.status;
        },
        triggerPermission(state) {
            if (state.status === 'unknown permission') {
                state.status = 'asking permission';
            }
        },
    },
});

export const { setStatus, triggerPermission, setKey } = pushNotificationSlice.actions;
